import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  & > .numberInputs {
    height: 100%;
    display: flex;
    justify-content: center;

    @media screen and (max-width: 427px) {
      flex-direction: column;

      & > .separator {
        display: none !important;
      }
    }
  }
`;

export const ModifiedInput = styled.div`
  & .react-numeric-input {
    width: 100px;
    height: 100%;

    @media screen and (max-width: 427px) {
      height: 34px;

      &:first-child {
        margin-bottom: 5px;
      }
    }

    & > input {
      height: 100%;
      border-radius: 9px !important;
      width: 100%;
    }

    & > b {
      border-radius: 5px !important;
      margin: 2px;
      cursor: pointer !important;

      &:hover {
        background: rgba(0, 0, 0, 0.15) !important;
      }
    }
  }
`;

export const Period = styled.div`
  width: 100px;
  height: 25px;
  border-radius: 9px;
  overflow: hidden;
  padding: 3px;
  background: #e3e3ec;

  @media screen and (max-width: 427px) {
    width: 60px;
    height: 68px;
  }

  & > div {
    background: #e3e3ec;
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;

    @media screen and (max-width: 427px) {
      flex-direction: column;
    }

    & > .period_option {
      position: absolute;
      height: 100%;
      width: 50%;
      z-index: 9;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      @media screen and (max-width: 427px) {
        width: 100%;
        height: 50%;
      }
    }

    & > .period_option:first-child {
      left: 0;
      @media screen and (max-width: 427px) {
        left: unset;
        top: 0;
      }
    }
    & > .period_option:nth-child(2) {
      right: 0;

      @media screen and (max-width: 427px) {
        right: unset;
        bottom: 0;
      }
    }

    & > .period_bg {
      box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      position: absolute;
      background: white;
      height: 100%;
      width: 50%;
      z-index: 2;
      transition: all 0.2s ease-in-out;
      transform: translateX(
        ${({ period }) => (period == 'AM' ? `0%` : `100%`)}
      );

      @media screen and (max-width: 427px) {
        height: 50%;
        width: 100%;

        transform: translateY(
          ${({ period }) => (period == 'AM' ? `0%` : `100%`)}
        );
      }

      &:hover {
        box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.12);
      }
    }
  }
`;
